var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullSizeImageMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42,40.5859375L30.7070312,29.2929688l-1.4140625,1.4140625L40.5859375,42H32v2h9c1.6542969,0,3-1.3457031,3-3v-9h-2 V40.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,4h-9v2h8.5859375L29.2929688,17.2929688l1.4140625,1.4140625L42,7.4140625V16h2V7C44,5.3457031,42.6542969,4,41,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6V4H7C5.3457031,4,4,5.3457031,4,7v9h2V7.4140625l11.2929688,11.2929688l1.4140625-1.4140625L7.4140625,6H16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2929688,29.2929688L6,40.5859375V32H4v9c0,1.6542969,1.3457031,3,3,3h9v-2H7.4140625l11.2929688-11.2929688 L17.2929688,29.2929688z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSizeImageMedium);
export default __webpack_public_path__ + "static/media/full-size-image--medium.086f4ce90382061bcbd9ef0346b97f7d.svg";
export { ForwardRef as ReactComponent };